import { render, staticRenderFns } from "./ImageUpload.vue?vue&type=template&id=3bbf0032&scoped=true&lang=pug&"
import script from "./ImageUpload.vue?vue&type=script&lang=coffee&"
export * from "./ImageUpload.vue?vue&type=script&lang=coffee&"
import style0 from "./ImageUpload.vue?vue&type=style&index=0&id=3bbf0032&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbf0032",
  null
  
)

export default component.exports